<template>
  <v-menu
    content-class="popover-menu-vuetify"
    offset-y
    v-bind:close-on-content-click="false"
    v-bind:value="active"
    v-on:update:return-value="onDialogClose"
  >
    <template v-slot:activator="{ on }">
      <slot
        name="trigger"
        v-bind:listener-object="on" />
    </template>
    <date-picker
      v-if="!active"
      v-bind:today="$options.today"
      v-bind:range="date"
      v-bind:auto-apply="true"
      v-model="date"
      v-on:input="setIsoDate"
    />
  </v-menu>
</template>
<script>
import DatePicker from '@/components/DatePicker.vue';

const NAME_EVENT_INPUT = 'input';
const NAME_EVENT_CLOSE = 'close';
/**
 * @description Компонент диалога выбора даты.
 * @type {Vue}
 */
export default {
  components: {
    DatePicker,
  },
  computed: {
    isoDate() {
      if (this.range) {
        return this.value.map((date) => date.toISOString().split('T')[0]);
      }
      return this.value.toISOString().split('T')[0];
    },
  },
  data() {
    return {
      active: false,
      date: this.value,
    };
  },
  name: 'DateRangePickerDialog',
  props: {
    value: { type: [Date, Array], required: true },
  },
  methods: {
    setIsoDate(updatedValue) {
      this.closeDialog();
      this.$emit(NAME_EVENT_INPUT, new Date(updatedValue));
    },
    /**
     * @description Обработать закрытие диалога.
     * @returns {void}
     */
    onDialogClose() {
      this.$emit(NAME_EVENT_CLOSE);
    },
    /**
     * @description Закрыть диалог.
     * @returns {void}
     */
    closeDialog() {
      this.active = true;
      this.$nextTick(() => {
        this.active = false;
      });
    },
  },
};
</script>
<style scoped>
.popover-menu-vuetify {
  background-color: var(--primary-background-color);
}
</style>
